__turbopack_context__.v({
  "active": "ai-module__DuPcEq__active",
  "adc_imageWrapper": "ai-module__DuPcEq__adc_imageWrapper",
  "adc_imageverticle": "ai-module__DuPcEq__adc_imageverticle",
  "agentCaseStudy": "ai-module__DuPcEq__agentCaseStudy",
  "agentCaseStudyCapabilities": "ai-module__DuPcEq__agentCaseStudyCapabilities",
  "agentCaseStudyCapabilitiesLabel": "ai-module__DuPcEq__agentCaseStudyCapabilitiesLabel",
  "agentCaseStudyCard": "ai-module__DuPcEq__agentCaseStudyCard",
  "agentCaseStudyDesc": "ai-module__DuPcEq__agentCaseStudyDesc",
  "agentCaseStudyEyebrow": "ai-module__DuPcEq__agentCaseStudyEyebrow",
  "agentCaseStudyImageWrap": "ai-module__DuPcEq__agentCaseStudyImageWrap",
  "agentCaseStudyLeft": "ai-module__DuPcEq__agentCaseStudyLeft",
  "agentCaseStudyStats": "ai-module__DuPcEq__agentCaseStudyStats",
  "agentCaseStudyTitle": "ai-module__DuPcEq__agentCaseStudyTitle",
  "agentsSlideInDown": "ai-module__DuPcEq__agentsSlideInDown",
  "agentsSlideInUp": "ai-module__DuPcEq__agentsSlideInUp",
  "agentsSliderViewport": "ai-module__DuPcEq__agentsSliderViewport",
  "aiApproach": "ai-module__DuPcEq__aiApproach",
  "aiApproachLight": "ai-module__DuPcEq__aiApproachLight",
  "aiBlobGlow": "ai-module__DuPcEq__aiBlobGlow",
  "aiBlobText": "ai-module__DuPcEq__aiBlobText",
  "aiBlobWrapper": "ai-module__DuPcEq__aiBlobWrapper",
  "aiCtaBanner": "ai-module__DuPcEq__aiCtaBanner",
  "aiCtaBannerDesc": "ai-module__DuPcEq__aiCtaBannerDesc",
  "aiCtaBannerImgFull": "ai-module__DuPcEq__aiCtaBannerImgFull",
  "aiCtaBannerImgWrap": "ai-module__DuPcEq__aiCtaBannerImgWrap",
  "aiCtaBannerInner": "ai-module__DuPcEq__aiCtaBannerInner",
  "aiCtaBannerLeft": "ai-module__DuPcEq__aiCtaBannerLeft",
  "aiCtaBannerLeftGrill": "ai-module__DuPcEq__aiCtaBannerLeftGrill",
  "aiCtaBannerRightGrill": "ai-module__DuPcEq__aiCtaBannerRightGrill",
  "aiCtaBannerTitle": "ai-module__DuPcEq__aiCtaBannerTitle",
  "aiDevPageTitle": "ai-module__DuPcEq__aiDevPageTitle",
  "aiHeroNew": "ai-module__DuPcEq__aiHeroNew",
  "aiHeroNewBtn": "ai-module__DuPcEq__aiHeroNewBtn",
  "aiHeroNewContent": "ai-module__DuPcEq__aiHeroNewContent",
  "aiHeroNewDesc": "ai-module__DuPcEq__aiHeroNewDesc",
  "aiHeroNewOverlay": "ai-module__DuPcEq__aiHeroNewOverlay",
  "aiHeroNewTitle": "ai-module__DuPcEq__aiHeroNewTitle",
  "aiHeroNewVideo": "ai-module__DuPcEq__aiHeroNewVideo",
  "aiInAction": "ai-module__DuPcEq__aiInAction",
  "aiInActionBottomLeft": "ai-module__DuPcEq__aiInActionBottomLeft",
  "aiInActionBottomRight": "ai-module__DuPcEq__aiInActionBottomRight",
  "aiInActionCapabilities": "ai-module__DuPcEq__aiInActionCapabilities",
  "aiInActionCapabilitiesLabel": "ai-module__DuPcEq__aiInActionCapabilitiesLabel",
  "aiInActionCard": "ai-module__DuPcEq__aiInActionCard",
  "aiInActionDesc": "ai-module__DuPcEq__aiInActionDesc",
  "aiInActionEyebrow": "ai-module__DuPcEq__aiInActionEyebrow",
  "aiInActionHeader": "ai-module__DuPcEq__aiInActionHeader",
  "aiInActionHire": "ai-module__DuPcEq__aiInActionHire",
  "aiInActionImageWrap": "ai-module__DuPcEq__aiInActionImageWrap",
  "aiInActionIntegration": "ai-module__DuPcEq__aiInActionIntegration",
  "aiInActionSplitCapabilities": "ai-module__DuPcEq__aiInActionSplitCapabilities",
  "aiInActionSplitCard": "ai-module__DuPcEq__aiInActionSplitCard",
  "aiInActionSplitContent": "ai-module__DuPcEq__aiInActionSplitContent",
  "aiInActionSplitDesc": "ai-module__DuPcEq__aiInActionSplitDesc",
  "aiInActionSplitEyebrow": "ai-module__DuPcEq__aiInActionSplitEyebrow",
  "aiInActionSplitImageWrap": "ai-module__DuPcEq__aiInActionSplitImageWrap",
  "aiInActionSplitLabel": "ai-module__DuPcEq__aiInActionSplitLabel",
  "aiInActionSplitStats": "ai-module__DuPcEq__aiInActionSplitStats",
  "aiInActionSplitTitle": "ai-module__DuPcEq__aiInActionSplitTitle",
  "aiInActionStats": "ai-module__DuPcEq__aiInActionStats",
  "aiInActionTitle": "ai-module__DuPcEq__aiInActionTitle",
  "aiIntegrationBizFunctionCard": "ai-module__DuPcEq__aiIntegrationBizFunctionCard",
  "aiIntegrationBizFunctionDesc": "ai-module__DuPcEq__aiIntegrationBizFunctionDesc",
  "aiIntegrationBizFunctionIcon": "ai-module__DuPcEq__aiIntegrationBizFunctionIcon",
  "aiIntegrationBizFunctionNumber": "ai-module__DuPcEq__aiIntegrationBizFunctionNumber",
  "aiIntegrationBizFunctionTitle": "ai-module__DuPcEq__aiIntegrationBizFunctionTitle",
  "aiIntegrationBizFunctionsNav": "ai-module__DuPcEq__aiIntegrationBizFunctionsNav",
  "aiIntegrationBizFunctionsNavBtn": "ai-module__DuPcEq__aiIntegrationBizFunctionsNavBtn",
  "aiIntegrationBizFunctionsNavBtnDisabled": "ai-module__DuPcEq__aiIntegrationBizFunctionsNavBtnDisabled",
  "aiIntegrationBizFunctionsSlider": "ai-module__DuPcEq__aiIntegrationBizFunctionsSlider",
  "aiIntegrationCost": "ai-module__DuPcEq__aiIntegrationCost",
  "aiIntegrationCostBody": "ai-module__DuPcEq__aiIntegrationCostBody",
  "aiIntegrationCostBtn": "ai-module__DuPcEq__aiIntegrationCostBtn",
  "aiIntegrationCostCell": "ai-module__DuPcEq__aiIntegrationCostCell",
  "aiIntegrationCostHead": "ai-module__DuPcEq__aiIntegrationCostHead",
  "aiIntegrationCostHeadCell": "ai-module__DuPcEq__aiIntegrationCostHeadCell",
  "aiIntegrationCostMobileLabel": "ai-module__DuPcEq__aiIntegrationCostMobileLabel",
  "aiIntegrationCostNote": "ai-module__DuPcEq__aiIntegrationCostNote",
  "aiIntegrationCostRow": "ai-module__DuPcEq__aiIntegrationCostRow",
  "aiIntegrationCostTable": "ai-module__DuPcEq__aiIntegrationCostTable",
  "aiIntegrationFactorCard": "ai-module__DuPcEq__aiIntegrationFactorCard",
  "aiIntegrationFactorDesc": "ai-module__DuPcEq__aiIntegrationFactorDesc",
  "aiIntegrationFactorIcon": "ai-module__DuPcEq__aiIntegrationFactorIcon",
  "aiIntegrationFactorTitle": "ai-module__DuPcEq__aiIntegrationFactorTitle",
  "aiIntegrationFactorsSection": "ai-module__DuPcEq__aiIntegrationFactorsSection",
  "aiIntegrationFactorsTitle": "ai-module__DuPcEq__aiIntegrationFactorsTitle",
  "aiIntegrationHero": "ai-module__DuPcEq__aiIntegrationHero",
  "aiIntegrationHeroBtn": "ai-module__DuPcEq__aiIntegrationHeroBtn",
  "aiIntegrationHeroBtnArrow": "ai-module__DuPcEq__aiIntegrationHeroBtnArrow",
  "aiIntegrationHeroCentered": "ai-module__DuPcEq__aiIntegrationHeroCentered",
  "aiIntegrationHeroContent": "ai-module__DuPcEq__aiIntegrationHeroContent",
  "aiIntegrationHeroDesc": "ai-module__DuPcEq__aiIntegrationHeroDesc",
  "aiIntegrationHeroOverlay": "ai-module__DuPcEq__aiIntegrationHeroOverlay",
  "aiIntegrationHeroTitle": "ai-module__DuPcEq__aiIntegrationHeroTitle",
  "aiIntegrationHeroVideo": "ai-module__DuPcEq__aiIntegrationHeroVideo",
  "aiIntegrationStackCard": "ai-module__DuPcEq__aiIntegrationStackCard",
  "aiIntegrationStackCardDesc": "ai-module__DuPcEq__aiIntegrationStackCardDesc",
  "aiIntegrationStackCardTitle": "ai-module__DuPcEq__aiIntegrationStackCardTitle",
  "aiIntegrationStackContent": "ai-module__DuPcEq__aiIntegrationStackContent",
  "aiIntegrationStackEyebrow": "ai-module__DuPcEq__aiIntegrationStackEyebrow",
  "aiIntegrationStackImageWrap": "ai-module__DuPcEq__aiIntegrationStackImageWrap",
  "aiIntegrationStatCard": "ai-module__DuPcEq__aiIntegrationStatCard",
  "aiIntegrationStatCell": "ai-module__DuPcEq__aiIntegrationStatCell",
  "aiIntegrationStatCellHighlight": "ai-module__DuPcEq__aiIntegrationStatCellHighlight",
  "aiIntegrationStatLabel": "ai-module__DuPcEq__aiIntegrationStatLabel",
  "aiIntegrationStatValue": "ai-module__DuPcEq__aiIntegrationStatValue",
  "aiIntegrationStats": "ai-module__DuPcEq__aiIntegrationStats",
  "aiIntegrationStatsDesc": "ai-module__DuPcEq__aiIntegrationStatsDesc",
  "aiIntegrationTechCard": "ai-module__DuPcEq__aiIntegrationTechCard",
  "aiIntegrationTechDesc": "ai-module__DuPcEq__aiIntegrationTechDesc",
  "aiIntegrationTechImg": "ai-module__DuPcEq__aiIntegrationTechImg",
  "aiIntegrationTechNav": "ai-module__DuPcEq__aiIntegrationTechNav",
  "aiIntegrationTechNavBtn": "ai-module__DuPcEq__aiIntegrationTechNavBtn",
  "aiIntegrationTechNavBtnDisabled": "ai-module__DuPcEq__aiIntegrationTechNavBtnDisabled",
  "aiIntegrationTechSlider": "ai-module__DuPcEq__aiIntegrationTechSlider",
  "aiIntegrationTechTitle": "ai-module__DuPcEq__aiIntegrationTechTitle",
  "aiRoadmap": "ai-module__DuPcEq__aiRoadmap",
  "ai_comparison": "ai-module__DuPcEq__ai_comparison",
  "ai_comparison_grid": "ai-module__DuPcEq__ai_comparison_grid",
  "ai_dev_casestudies": "ai-module__DuPcEq__ai_dev_casestudies",
  "ai_our_work": "ai-module__DuPcEq__ai_our_work",
  "ai_roadmap_team_sec": "ai-module__DuPcEq__ai_roadmap_team_sec",
  "aiml_technologies": "ai-module__DuPcEq__aiml_technologies",
  "approachImgWrap": "ai-module__DuPcEq__approachImgWrap",
  "approachNumber": "ai-module__DuPcEq__approachNumber",
  "approachRow": "ai-module__DuPcEq__approachRow",
  "approachRowHighlight": "ai-module__DuPcEq__approachRowHighlight",
  "approachStepDesc": "ai-module__DuPcEq__approachStepDesc",
  "approachStepTitle": "ai-module__DuPcEq__approachStepTitle",
  "art_btn": "ai-module__DuPcEq__art_btn",
  "art_btn_orange": "ai-module__DuPcEq__art_btn_orange",
  "art_card": "ai-module__DuPcEq__art_card",
  "art_desc": "ai-module__DuPcEq__art_desc",
  "art_dev_imgs": "ai-module__DuPcEq__art_dev_imgs",
  "art_experts_list": "ai-module__DuPcEq__art_experts_list",
  "art_text": "ai-module__DuPcEq__art_text",
  "art_title": "ai-module__DuPcEq__art_title",
  "backward": "ai-module__DuPcEq__backward",
  "bg-black": "ai-module__DuPcEq__bg-black",
  "bg-white": "ai-module__DuPcEq__bg-white",
  "bi_item": "ai-module__DuPcEq__bi_item",
  "bi_item_desc": "ai-module__DuPcEq__bi_item_desc",
  "bi_item_title": "ai-module__DuPcEq__bi_item_title",
  "blob": "ai-module__DuPcEq__blob",
  "blobGlowAnim": "ai-module__DuPcEq__blobGlowAnim",
  "blobText": "ai-module__DuPcEq__blobText",
  "block_text": "ai-module__DuPcEq__block_text",
  "block_title": "ai-module__DuPcEq__block_title",
  "blog_insight": "ai-module__DuPcEq__blog_insight",
  "blue": "ai-module__DuPcEq__blue",
  "border_top_gray": "ai-module__DuPcEq__border_top_gray",
  "btnPrimary": "ai-module__DuPcEq__btnPrimary",
  "btn_icon": "ai-module__DuPcEq__btn_icon",
  "build_smarter_ai": "ai-module__DuPcEq__build_smarter_ai",
  "businessValueCard": "ai-module__DuPcEq__businessValueCard",
  "businessValueDesc": "ai-module__DuPcEq__businessValueDesc",
  "businessValueIcon": "ai-module__DuPcEq__businessValueIcon",
  "businessValueText": "ai-module__DuPcEq__businessValueText",
  "businessValueTitle": "ai-module__DuPcEq__businessValueTitle",
  "capabilitiesBadge": "ai-module__DuPcEq__capabilitiesBadge",
  "capabilitiesCell": "ai-module__DuPcEq__capabilitiesCell",
  "capabilitiesColName": "ai-module__DuPcEq__capabilitiesColName",
  "capabilitiesRow": "ai-module__DuPcEq__capabilitiesRow",
  "capabilitiesTable": "ai-module__DuPcEq__capabilitiesTable",
  "cardBody": "ai-module__DuPcEq__cardBody",
  "cardDescription": "ai-module__DuPcEq__cardDescription",
  "cardFooter": "ai-module__DuPcEq__cardFooter",
  "cardHeader": "ai-module__DuPcEq__cardHeader",
  "cardStack": "ai-module__DuPcEq__cardStack",
  "cardTitle": "ai-module__DuPcEq__cardTitle",
  "cardWrapper": "ai-module__DuPcEq__cardWrapper",
  "card_desc": "ai-module__DuPcEq__card_desc",
  "card_list": "ai-module__DuPcEq__card_list",
  "card_title": "ai-module__DuPcEq__card_title",
  "case_item": "ai-module__DuPcEq__case_item",
  "commonPad": "ai-module__DuPcEq__commonPad",
  "ctaButton": "ai-module__DuPcEq__ctaButton",
  "ctaButtonIcon": "ai-module__DuPcEq__ctaButtonIcon",
  "customAiCard": "ai-module__DuPcEq__customAiCard",
  "customAiCardCovers": "ai-module__DuPcEq__customAiCardCovers",
  "customAiCardDesc": "ai-module__DuPcEq__customAiCardDesc",
  "customAiCardImgWrap": "ai-module__DuPcEq__customAiCardImgWrap",
  "customAiCardList": "ai-module__DuPcEq__customAiCardList",
  "customAiCardListLabel": "ai-module__DuPcEq__customAiCardListLabel",
  "customAiCardRow": "ai-module__DuPcEq__customAiCardRow",
  "customAiCardTitle": "ai-module__DuPcEq__customAiCardTitle",
  "dark": "ai-module__DuPcEq__dark",
  "description": "ai-module__DuPcEq__description",
  "devCostCell": "ai-module__DuPcEq__devCostCell",
  "devCostColCost": "ai-module__DuPcEq__devCostColCost",
  "devCostColFeatures": "ai-module__DuPcEq__devCostColFeatures",
  "devCostColSolution": "ai-module__DuPcEq__devCostColSolution",
  "devCostColTimeline": "ai-module__DuPcEq__devCostColTimeline",
  "devCostHead": "ai-module__DuPcEq__devCostHead",
  "devCostHeadRow": "ai-module__DuPcEq__devCostHeadRow",
  "devCostRange": "ai-module__DuPcEq__devCostRange",
  "devCostRow": "ai-module__DuPcEq__devCostRow",
  "devCostTable": "ai-module__DuPcEq__devCostTable",
  "engagementCard": "ai-module__DuPcEq__engagementCard",
  "engagementModels": "ai-module__DuPcEq__engagementModels",
  "enterpriseReady": "ai-module__DuPcEq__enterpriseReady",
  "enterpriseReadyFadeIn": "ai-module__DuPcEq__enterpriseReadyFadeIn",
  "enterpriseReadyNav": "ai-module__DuPcEq__enterpriseReadyNav",
  "enterpriseReadyNavItem": "ai-module__DuPcEq__enterpriseReadyNavItem",
  "enterpriseReadyNavItemActive": "ai-module__DuPcEq__enterpriseReadyNavItemActive",
  "enterpriseReadyPanel": "ai-module__DuPcEq__enterpriseReadyPanel",
  "enterpriseReadyPanelContent": "ai-module__DuPcEq__enterpriseReadyPanelContent",
  "enterpriseReadyPanelDesc": "ai-module__DuPcEq__enterpriseReadyPanelDesc",
  "enterpriseReadyPanelIcon": "ai-module__DuPcEq__enterpriseReadyPanelIcon",
  "enterpriseReadyPanelImageWrap": "ai-module__DuPcEq__enterpriseReadyPanelImageWrap",
  "enterpriseReadyPanelTitle": "ai-module__DuPcEq__enterpriseReadyPanelTitle",
  "extraGap": "ai-module__DuPcEq__extraGap",
  "faq_ai_page": "ai-module__DuPcEq__faq_ai_page",
  "faq_ans": "ai-module__DuPcEq__faq_ans",
  "faq_que": "ai-module__DuPcEq__faq_que",
  "featureCard": "ai-module__DuPcEq__featureCard",
  "featureIcon": "ai-module__DuPcEq__featureIcon",
  "featureItem": "ai-module__DuPcEq__featureItem",
  "featureText": "ai-module__DuPcEq__featureText",
  "feature_card": "ai-module__DuPcEq__feature_card",
  "feature_card_dark": "ai-module__DuPcEq__feature_card_dark",
  "feature_card_light": "ai-module__DuPcEq__feature_card_light",
  "feature_item": "ai-module__DuPcEq__feature_item",
  "featuresLabel": "ai-module__DuPcEq__featuresLabel",
  "featuresList": "ai-module__DuPcEq__featuresList",
  "featuresSection": "ai-module__DuPcEq__featuresSection",
  "fiveCardCol": "ai-module__DuPcEq__fiveCardCol",
  "flexible_card": "ai-module__DuPcEq__flexible_card",
  "flexible_card_avatar": "ai-module__DuPcEq__flexible_card_avatar",
  "flexible_card_avatars": "ai-module__DuPcEq__flexible_card_avatars",
  "flexible_card_btn": "ai-module__DuPcEq__flexible_card_btn",
  "flexible_card_desc": "ai-module__DuPcEq__flexible_card_desc",
  "flexible_card_field": "ai-module__DuPcEq__flexible_card_field",
  "flexible_card_fields": "ai-module__DuPcEq__flexible_card_fields",
  "flexible_card_header": "ai-module__DuPcEq__flexible_card_header",
  "flexible_card_icon": "ai-module__DuPcEq__flexible_card_icon",
  "flexible_card_label": "ai-module__DuPcEq__flexible_card_label",
  "flexible_card_title": "ai-module__DuPcEq__flexible_card_title",
  "flexible_card_value": "ai-module__DuPcEq__flexible_card_value",
  "forward": "ai-module__DuPcEq__forward",
  "framImg": "ai-module__DuPcEq__framImg",
  "frameworkChip": "ai-module__DuPcEq__frameworkChip",
  "frameworkChipOuter": "ai-module__DuPcEq__frameworkChipOuter",
  "frameworks": "ai-module__DuPcEq__frameworks",
  "frameworksGrid": "ai-module__DuPcEq__frameworksGrid",
  "gray": "ai-module__DuPcEq__gray",
  "grid_column": "ai-module__DuPcEq__grid_column",
  "had_badge": "ai-module__DuPcEq__had_badge",
  "had_btn": "ai-module__DuPcEq__had_btn",
  "had_dev_imgs": "ai-module__DuPcEq__had_dev_imgs",
  "had_num": "ai-module__DuPcEq__had_num",
  "had_text": "ai-module__DuPcEq__had_text",
  "had_title": "ai-module__DuPcEq__had_title",
  "half-black": "ai-module__DuPcEq__half-black",
  "half-black-top": "ai-module__DuPcEq__half-black-top",
  "half-grey": "ai-module__DuPcEq__half-grey",
  "half-grey-bot": "ai-module__DuPcEq__half-grey-bot",
  "highlight": "ai-module__DuPcEq__highlight",
  "hireHero": "ai-module__DuPcEq__hireHero",
  "hireHeroBtn": "ai-module__DuPcEq__hireHeroBtn",
  "hireHeroContent": "ai-module__DuPcEq__hireHeroContent",
  "hireHeroDesc": "ai-module__DuPcEq__hireHeroDesc",
  "hireHeroInner": "ai-module__DuPcEq__hireHeroInner",
  "hireHeroOverlay": "ai-module__DuPcEq__hireHeroOverlay",
  "hireHeroTitle": "ai-module__DuPcEq__hireHeroTitle",
  "hireHeroVideo": "ai-module__DuPcEq__hireHeroVideo",
  "hireai_developer_sec": "ai-module__DuPcEq__hireai_developer_sec",
  "hoverable_item": "ai-module__DuPcEq__hoverable_item",
  "hovered": "ai-module__DuPcEq__hovered",
  "icon": "ai-module__DuPcEq__icon",
  "iconBg": "ai-module__DuPcEq__iconBg",
  "iconShape": "ai-module__DuPcEq__iconShape",
  "iconWrapper": "ai-module__DuPcEq__iconWrapper",
  "imageWrapper": "ai-module__DuPcEq__imageWrapper",
  "industrySolutionCard": "ai-module__DuPcEq__industrySolutionCard",
  "industrySolutionCardDesc": "ai-module__DuPcEq__industrySolutionCardDesc",
  "industrySolutionCardImg": "ai-module__DuPcEq__industrySolutionCardImg",
  "industrySolutionCardTitle": "ai-module__DuPcEq__industrySolutionCardTitle",
  "industrySolutions": "ai-module__DuPcEq__industrySolutions",
  "industrySolutionsBlue": "ai-module__DuPcEq__industrySolutionsBlue",
  "industrySolutionsSlider": "ai-module__DuPcEq__industrySolutionsSlider",
  "innerWrapper": "ai-module__DuPcEq__innerWrapper",
  "item": "ai-module__DuPcEq__item",
  "left": "ai-module__DuPcEq__left",
  "light": "ai-module__DuPcEq__light",
  "max_w_75": "ai-module__DuPcEq__max_w_75",
  "modernAiTech": "ai-module__DuPcEq__modernAiTech",
  "modernAiTechCell": "ai-module__DuPcEq__modernAiTechCell",
  "modernAiTechGrid": "ai-module__DuPcEq__modernAiTechGrid",
  "modernAiTechIcon": "ai-module__DuPcEq__modernAiTechIcon",
  "modernAiTechLabel": "ai-module__DuPcEq__modernAiTechLabel",
  "modernAiTechTitleMuted": "ai-module__DuPcEq__modernAiTechTitleMuted",
  "ourProcessNew": "ai-module__DuPcEq__ourProcessNew",
  "overviewSection": "ai-module__DuPcEq__overviewSection",
  "overviewSubtitle": "ai-module__DuPcEq__overviewSubtitle",
  "overviewTitle": "ai-module__DuPcEq__overviewTitle",
  "partnerCard": "ai-module__DuPcEq__partnerCard",
  "partnerList": "ai-module__DuPcEq__partnerList",
  "partnerListIcon": "ai-module__DuPcEq__partnerListIcon",
  "processCard": "ai-module__DuPcEq__processCard",
  "pulse": "ai-module__DuPcEq__pulse",
  "responsibleAi": "ai-module__DuPcEq__responsibleAi",
  "responsibleAiContentFadeIn": "ai-module__DuPcEq__responsibleAiContentFadeIn",
  "responsibleAiDark": "ai-module__DuPcEq__responsibleAiDark",
  "responsibleAiHighlight": "ai-module__DuPcEq__responsibleAiHighlight",
  "responsibleAiImgWrap": "ai-module__DuPcEq__responsibleAiImgWrap",
  "responsibleAiItem": "ai-module__DuPcEq__responsibleAiItem",
  "responsibleAiItemActive": "ai-module__DuPcEq__responsibleAiItemActive",
  "responsibleAiItemContent": "ai-module__DuPcEq__responsibleAiItemContent",
  "responsibleAiNumber": "ai-module__DuPcEq__responsibleAiNumber",
  "responsibleAiSlider": "ai-module__DuPcEq__responsibleAiSlider",
  "responsibleAiTab": "ai-module__DuPcEq__responsibleAiTab",
  "responsibleAiTabLabel": "ai-module__DuPcEq__responsibleAiTabLabel",
  "responsibleAiTabNumber": "ai-module__DuPcEq__responsibleAiTabNumber",
  "roadMapTeamsSlider": "ai-module__DuPcEq__roadMapTeamsSlider",
  "roadmapCard": "ai-module__DuPcEq__roadmapCard",
  "roadmapCardDesc": "ai-module__DuPcEq__roadmapCardDesc",
  "roadmapCardNumber": "ai-module__DuPcEq__roadmapCardNumber",
  "roadmapCardTag": "ai-module__DuPcEq__roadmapCardTag",
  "roadmapCardTags": "ai-module__DuPcEq__roadmapCardTags",
  "roadmapCardTitle": "ai-module__DuPcEq__roadmapCardTitle",
  "roadmapCompact": "ai-module__DuPcEq__roadmapCompact",
  "roadmapProgressFill": "ai-module__DuPcEq__roadmapProgressFill",
  "roadmapProgressTrack": "ai-module__DuPcEq__roadmapProgressTrack",
  "roadmapTimeline": "ai-module__DuPcEq__roadmapTimeline",
  "roadmapTimelineCard": "ai-module__DuPcEq__roadmapTimelineCard",
  "roadmapTimelineItem": "ai-module__DuPcEq__roadmapTimelineItem",
  "roadmapTimelineMarker": "ai-module__DuPcEq__roadmapTimelineMarker",
  "rotateDown": "ai-module__DuPcEq__rotateDown",
  "rotateUp": "ai-module__DuPcEq__rotateUp",
  "rounded_circle": "ai-module__DuPcEq__rounded_circle",
  "scaleImg": "ai-module__DuPcEq__scaleImg",
  "sec_subtitle": "ai-module__DuPcEq__sec_subtitle",
  "sec_title": "ai-module__DuPcEq__sec_title",
  "sec_title2": "ai-module__DuPcEq__sec_title2",
  "section-desc": "ai-module__DuPcEq__section-desc",
  "section-title": "ai-module__DuPcEq__section-title",
  "sectionSubTitle": "ai-module__DuPcEq__sectionSubTitle",
  "sectionTitle": "ai-module__DuPcEq__sectionTitle",
  "sectionTitleWrap": "ai-module__DuPcEq__sectionTitleWrap",
  "slickSlidePad": "ai-module__DuPcEq__slickSlidePad",
  "slideInBackward": "ai-module__DuPcEq__slideInBackward",
  "slideInForward": "ai-module__DuPcEq__slideInForward",
  "slider": "ai-module__DuPcEq__slider",
  "sliderLoopPeek": "ai-module__DuPcEq__sliderLoopPeek",
  "smarterApprochCompareSection": "ai-module__DuPcEq__smarterApprochCompareSection",
  "stackCardInner": "ai-module__DuPcEq__stackCardInner",
  "stackCardSticky": "ai-module__DuPcEq__stackCardSticky",
  "stackPad": "ai-module__DuPcEq__stackPad",
  "statCell": "ai-module__DuPcEq__statCell",
  "statCellHighlight": "ai-module__DuPcEq__statCellHighlight",
  "statLabel": "ai-module__DuPcEq__statLabel",
  "statValue": "ai-module__DuPcEq__statValue",
  "stickyHead": "ai-module__DuPcEq__stickyHead",
  "stickyList": "ai-module__DuPcEq__stickyList",
  "stickyListContent": "ai-module__DuPcEq__stickyListContent",
  "stickyListDesc": "ai-module__DuPcEq__stickyListDesc",
  "stickyListHead": "ai-module__DuPcEq__stickyListHead",
  "stickyListImg": "ai-module__DuPcEq__stickyListImg",
  "stickyListLight": "ai-module__DuPcEq__stickyListLight",
  "stickyListNumber": "ai-module__DuPcEq__stickyListNumber",
  "stickyListRow": "ai-module__DuPcEq__stickyListRow",
  "stickyListText": "ai-module__DuPcEq__stickyListText",
  "stickyListTitle": "ai-module__DuPcEq__stickyListTitle",
  "teamTabsLink": "ai-module__DuPcEq__teamTabsLink",
  "teamTabsNav": "ai-module__DuPcEq__teamTabsNav",
  "techFrameworksLabel": "ai-module__DuPcEq__techFrameworksLabel",
  "techFrameworksRow": "ai-module__DuPcEq__techFrameworksRow",
  "techFrameworksTag": "ai-module__DuPcEq__techFrameworksTag",
  "techFrameworksTags": "ai-module__DuPcEq__techFrameworksTags",
  "techStackCard": "ai-module__DuPcEq__techStackCard",
  "techStackCardIcon": "ai-module__DuPcEq__techStackCardIcon",
  "techStackCardIn": "ai-module__DuPcEq__techStackCardIn",
  "techStackDropdown": "ai-module__DuPcEq__techStackDropdown",
  "techStackDropdownDark": "ai-module__DuPcEq__techStackDropdownDark",
  "techStackNav": "ai-module__DuPcEq__techStackNav",
  "techStackNavDark": "ai-module__DuPcEq__techStackNavDark",
  "techStackNavLink": "ai-module__DuPcEq__techStackNavLink",
  "techStackNavLinkDark": "ai-module__DuPcEq__techStackNavLinkDark",
  "techStackTabs": "ai-module__DuPcEq__techStackTabs",
  "text_grey": "ai-module__DuPcEq__text_grey",
  "text_oldsilver": "ai-module__DuPcEq__text_oldsilver",
  "theme-primary-btn": "ai-module__DuPcEq__theme-primary-btn",
  "timeline": "ai-module__DuPcEq__timeline",
  "timelineCenterDot": "ai-module__DuPcEq__timelineCenterDot",
  "timelineCenterLine": "ai-module__DuPcEq__timelineCenterLine",
  "timelineDot": "ai-module__DuPcEq__timelineDot",
  "timelineDotStatic": "ai-module__DuPcEq__timelineDotStatic",
  "timelineLine": "ai-module__DuPcEq__timelineLine",
  "timelineLineStatic": "ai-module__DuPcEq__timelineLineStatic",
  "timelineStatic": "ai-module__DuPcEq__timelineStatic",
  "title": "ai-module__DuPcEq__title",
  "validateAiIdea": "ai-module__DuPcEq__validateAiIdea",
  "validateAiIdeaLight": "ai-module__DuPcEq__validateAiIdeaLight",
  "validateStep": "ai-module__DuPcEq__validateStep",
  "validateStepDesc": "ai-module__DuPcEq__validateStepDesc",
  "validateStepHighlight": "ai-module__DuPcEq__validateStepHighlight",
  "validateStepNumber": "ai-module__DuPcEq__validateStepNumber",
  "validateStepTitle": "ai-module__DuPcEq__validateStepTitle",
  "verticalSliderNavBtn": "ai-module__DuPcEq__verticalSliderNavBtn",
});
